import { List } from '@mui/material'
import React, { useState } from 'react'

import { NavItem } from 'components/navigation/Nav/NavItem'
import { useGremlinNavigation } from 'components/navigation/Nav/use-gremlin-navigation'

export const NavItemList: React.FC<{
  userHasTeams: boolean
}> = ({ userHasTeams }) => {
  const { navigationConfigItems } = useGremlinNavigation({
    userHasTeams
  })

  const [selectedNavItem, setSelectedNavItem] = useState<string | null>(null)

  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto'
      }}
    >
      {navigationConfigItems.map((navItem) => {
        if (!navItem.enabled) {
          return null
        }

        return (
          <NavItem
            key={navItem.text}
            navItem={navItem}
            selectedNavItem={selectedNavItem}
            setSelectedNavItem={setSelectedNavItem}
          />
        )
      })}
    </List>
  )
}
